// Just for small react elements that don't need to be components
import React from 'react';

export const PhoneElement = <a href='tel:137788'>13 77 88</a>;
